import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Drawer as KendoDrawerComponent } from '@progress/kendo-react-layout';

import { useAuth0 } from '../auth';
import { displayDrawerMenu } from './navigation.actions';
import { isDrawerMenuVisible } from './navigation.selectors';
import menuConfig from './menuConfig';

const DrawerComponent = (props) => {

    const history = useHistory();
    const { logout } = useAuth0();

    const logoutText  = 'Logout';

    const handleSelect = (event) => {
        props.onOverlayClick(false);

        const target = event.itemTarget;
        if(target.element.current.textContent === logoutText) {
            logout({ returnTo: window.location.origin });
            return;
        }
        history.push(target.props.path);
    };

    const handleOverlayClick = () => {
        props.onOverlayClick(false);
    };

    const isSelected = (item) => {
        const result = (item.path === menuConfig.root && window.location.pathname === menuConfig.root) || 
                        (item.path !== menuConfig.root && window.location.pathname.startsWith(item.path));
        return result;
    };

    const drawerItems = menuConfig.items.map(configItem => ( { ...configItem, selected: isSelected(configItem) } ));

    //Add Logout
    drawerItems.push({ separator: true});
    drawerItems.push({ text: logoutText });

    return (
        <KendoDrawerComponent expanded={props.displayMenu} items={drawerItems}
            position="start" mode="overlay" 
            onSelect={handleSelect} onOverlayClick={handleOverlayClick}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        displayMenu: isDrawerMenuVisible(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = {
        onOverlayClick: (visible) => dispatch(displayDrawerMenu(visible))
    };
    return props;
};

const Drawer = connect(mapStateToProps, mapDispatchToProps)(DrawerComponent);
export default Drawer;
